import { render, staticRenderFns } from "./CODByShippingService.vue?vue&type=template&id=2ce44c67"
import script from "./CODByShippingService.vue?vue&type=script&lang=js"
export * from "./CODByShippingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports